/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaInputAddressPickerChoice/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function TysiaInputAddressPickerChoice({
  children,
  viewPath = "/DesignSystem/TysiaInput/TysiaInputAddressPicker/TysiaInputAddressPickerChoice",
  onClick,
  isSelected,
  description
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsGreen300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.300'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsGreen700alpha15 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700alpha.15'
        })
  return (<React.Fragment
>
<button
  data-testid="TysiaInputAddressPickerChoice.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bblr-2-1aoAMY': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-1aoAMY': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-4-1aoAMY': dtColorsGreen300,'--btlr-5-1aoAMY': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-6-1aoAMY': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mt-7-1aoAMY': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-8-1aoAMY': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-9-1aoAMY': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-10-1aoAMY': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-11-1aoAMY': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-1-1aoAMY': isSelected ? dtColorsNeutral200 : isHovered ? dtColorsGreen700alpha15 : dtColorsNeutral100}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={14}
 paddingBottom={dtSpaceXs}
 paddingLeft={dtSpaceXs}
 paddingRight={dtSpaceXs}
 paddingTop={dtSpaceXs}
 text={description}
/>
</button>
{children}
</React.Fragment>)
}